module.exports = __webpack_public_path__ + "static/media/pg.e5877087.svg";